// 目标指标
import http from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 分页查询-tr
export function getKpiReportList(data) {
    return http({
        url: apiCrmHost + '/goal/manage/kpi/page',
        method: 'post',
        data
    });
};
// 导入-tr
export function importKpiReportList(data) {
    return http({
        url: apiCrmHost + '/goal/manage/kpi/import',
        method: 'post',
        data
    });
};
// 删除-tr
export function deleteKpiReportList(data) {
    return http({
        url: apiCrmHost + '/goal/manage/kpi/deleteBatch',
        method: 'post',
        data
    });
};
// 导出-tr
export function exportKpiReportList(data) {
    return http({
        url: apiCrmHost + '/goal/manage/kpi/export',
        method: 'post',
        data
    });
};
